import React from 'react';

// 화면 아이콘 모음. 이름 → 이모지(또는 글자 기호)
// 2026-10-27 한때 선 아이콘(SVG)으로 바꿨으나 "밋밋하고 어색하다"는 의견으로 예전 이모지 모양으로 되돌렸다.
// 아이콘을 쓰는 곳은 그대로 두고 여기서만 모양을 정한다.
const ICONS = {
    menu: '☰',
    chat: '💬',
    download: '📦',
    shield: '⚙️',
    bell: '🔔',
    bellActive: '🔔',
    bellOff: '🔕',
    at: '📥',
    users: '👥',
    user: '👤',
    moon: '🌙',
    sun: '☀️',
    logout: '⏏',
    folder: '🗂️',
    bookmark: '🔖',
    search: '🔍',
    display: '🖥️',
    send: '✔️',
    plus: '📎',
    smile: '😊',
    reply: '↪️',
    more: '⋯',
    edit: '✏️',
    copy: '📋',
    link: '🔗',
    trash: '🗑️',
    x: '✕',
    image: '🖼️',
    paperclip: '📎',
    code: '</>',
    undo: '🔄',
    megaphone: '📢',
    lock: '🔒',
    hash: '#',
    pin: '📌',
    chevronLeft: '‹',
    chevronRight: '›',
};

export function Icon({ name, size = 20, className, style, ...rest }) {
    return (
        <span aria-hidden="true" {...rest}
            className={className ? `icon ${className}` : 'icon'}
            style={{ fontSize: Math.round(size * 0.85), width: size, height: size, ...style }}>
            {ICONS[name] ?? ''}
        </span>
    );
}
